import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import log from '../../shared/utils/log';
import { RuntimeContext } from '../../../common/RuntimeContext';

import LoadingIndicator from '../../shared/components/LoadingIndicator';
import { loginCallback } from '../../shared/actions';
import { setLocalStorage, getLocalStorage } from '../../shared/actions/LocalStorage';

class AuthCallback extends Component {
    static propTypes = {
        loginCallback: PropTypes.func.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired,
        languageLoaded: PropTypes.bool,
        auth: {
            isAuthenticated: PropTypes.bool,
            isVerbAdmin: PropTypes.bool,
            loggedInUser: PropTypes.object,
            loggedInUserId: PropTypes.string,
            loggedInUserCompanyId: PropTypes.string
        },
        userCompany: PropTypes.object
    };

    static contextType = RuntimeContext;

    _identifySegmentUser = () => {
        const {
            auth: { isAuthenticated, loggedInUserId, loggedInUserCompanyId }
        } = this.props;
        let promise = Promise.resolve({});
        if (isAuthenticated && loggedInUserId) {
            promise = this.getLoggedInUserData(loggedInUserId, loggedInUserCompanyId);
        }
        promise().then(() => {
            const {
                auth: {
                    isVerbAdmin,
                    loggedInUser: { firstName = '', lastName = '', email = '' },
                    loggedInUserId
                },
                userCompany = {}
            } = this.props;
            const name = `${firstName} ${lastName}`;
            const currentDateTime = new Date();
            setLocalStorage({
                key: 'segmentLastIdentifyDate',
                value: currentDateTime,
                dispatchDisabled: true
            });
        });
    };

    componentDidMount() {
        const loginUrl = document.referrer
            .replace(/^[^:]+:\/\/[^/]+/, '')
            .replace(/#.*/, '')
            .replace(/\?.*/, '');
        const { loginCallback, history, location, authContext, nextPath } = this.props;
        let passThroughParams = queryString.parse(location.search);

        if (nextPath) {
            passThroughParams = { nextPath };
        }

        const params = {
            history,
            passThroughParams,
            pathsContext: this.context.pathsWeb,
            authContext,
        };
        loginCallback(params)
            .then(() => {
                const segmentLastIdentifyDate = getLocalStorage({
                    key: 'segmentLastIdentifyDate',
                    dispatchDisabled: true
                });
                const currentDateTime = new Date();
                const dateTime30MinAgo = new Date(currentDateTime.getTime() - 30 * 60000);

                if (
                    this.props.auth.isAuthenticated &&
                    this.props.auth.loggedInUserId &&
                    segmentLastIdentifyDate &&
                    segmentLastIdentifyDate < dateTime30MinAgo
                ) {
                    this._identifySegmentUser(this.props.auth.loggedInUserId);
                }
            })
            .catch((err) => {
                log.error(`Login error in AuthCallback. [Hash: ${location.hash}]. Error: ${JSON.stringify(err)}`);
                history.push(loginUrl, { auth: { error: JSON.stringify(err) } });
            });
    }

    render = () => (
        <div className={'full-page-loading-spinner'}>
            <LoadingIndicator />
        </div>
    );
}

const mapStateToProps = (state) => {
    const { languageLoaded } = state.language;
    const { companies } = state;

    return {
        languageLoaded,
        auth: state.auth,
        userCompany: companies.byId[state.auth.loggedInUserCompanyId] || {}
    };
};

const mapDispatchToProps = (dispatch) => ({
    loginCallback: (params) => dispatch(loginCallback(params))
});

export const AuthCallbackComponent = AuthCallback;
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AuthCallback));
